import registerFormBlock from '../gutenberg/FormBlock/registerFormBlock';
import { initBackgroundApp } from '../utils/backgroundAppUtils';

initBackgroundApp(registerFormBlock);
